import { API, generic } from "api"

export default class LetterTemplatesService {
  static index = async ({ pageState, page = 1, pageSize = 25 }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_LETTER_TEMPLATES_INDEX_STATUS",
      stateDataKey: [
        "letter_templates",
        "total",
        "page",
        "page_size",
        "criteria_keys",
      ],
      stateErrorKey: [
        "letterTemplatesErrors",
        "totalErrors",
        "pageErrors",
        "pageSizeErrors",
        "criteriaKeysErrors",
      ],
      apiEndpoint: API.users.letterTemplates.index,
      apiUrlReplacements: {},
      apiData: { params: { page, page_size: pageSize } },
      errorMessage: "Letter Templates could not be fetched.",
    })
  }

  static create = async ({ pageState, values }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_LETTER_TEMPLATES_CREATE_STATUS",
      stateDataKey: ["letter_template"],
      stateErrorKey: ["letterTemplateErrors"],
      apiEndpoint: API.users.letterTemplates.create,
      apiUrlReplacements: {},
      apiData: { ...values },
      errorMessage: "Letter Template could not be created.",
    })
  }

  static show = async ({ pageState, letterTemplateId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_LETTER_TEMPLATES_SHOW_STATUS",
      stateDataKey: ["letter_template"],
      stateErrorKey: ["LetterTemplateErrors"],
      apiEndpoint: API.users.letterTemplates.show,
      apiUrlReplacements: { letterTemplateId },
      apiData: {},
      errorMessage: "Letter Template could not be fetched.",
    })
  }

  static update = async ({ pageState, values, letterTemplateId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_LETTER_TEMPLATES_UPDATE_STATUS",
      stateDataKey: ["letter_template"],
      stateErrorKey: ["LetterTemplateErrors"],
      apiEndpoint: API.users.letterTemplates.update,
      apiUrlReplacements: { letterTemplateId },
      apiData: { ...values },
      errorMessage: "Letter Template could not be updated.",
    })
  }

  static refresh = async ({ pageState, fitmentId }) => {
    await generic({
			pageState,
			stateApiStatusKey: 'API_USERS_LETTER_TEMPLATES_REFRESH_STATUS',
			stateDataKey: ['fitment'],
			stateErrorKey: ['fitmentErrors'],
			apiEndpoint: API.users.fitments.letterTemplates.refresh,
			apiUrlReplacements: { fitmentId },
			apiData: {},
			errorMessage: 'Letter Template could not be refreshed.',
		})
  }

  static delete = async ({ pageState, letterTemplateId }) => {
    await generic({
      pageState,
      stateApiStatusKey: 'API_USERS_LETTER_TEMPLATES_DELETE_STATUS',
      stateDataKey: ['message'],
      stateErrorKey: ['letterTemplateErrors'],
      apiEndpoint: API.users.letterTemplates.delete,
      apiUrlReplacements: { letterTemplateId },
      apiData: {},
      errorMessage: 'Letter Template could not be Deleted.',
      serializedResponse : false,
    })
  }

  static previewAdditionalLetter = async ({ pageState, letterTemplateId, fitmentId }) => {
    const params = {}
    if (fitmentId) params.fitment_id = fitmentId
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_LETTER_TEMPLATES_PREVIEW_STATUS",
      stateDataKey: ["preview"],
      stateErrorKey: ["previewErrors"],
      apiEndpoint: API.users.letterTemplates.previewAdditionalLetter,
      apiUrlReplacements: { letterTemplateId },
      apiData: { params },
      errorMessage: "Letter Template preview could not be generated.",
      serializedResponse: false,
    })
  }

  static fitments = async ({ pageState, letterTemplateId }) => {
    await generic({
      pageState,
      stateApiStatusKey: "API_USERS_LETTER_TEMPLATES_FITMENTS_STATUS",
      stateDataKey: ["fitments"],
      stateErrorKey: ["fitmentsErrors"],
      apiEndpoint: API.users.letterTemplates.fitments,
      apiUrlReplacements: { letterTemplateId },
      apiData: {},
      errorMessage: "Fitments could not be fetched.",
      serializedResponse: false,
    })
  }

}
